<template>
  <nav id="bar">
    <ul>
      <li
        v-for="link in links"
        :key="link.path"
      >
        <router-link :to="link.path">
          {{ link.name }}
        </router-link>
      </li>
      <li>
        <img
          src="@/assets/images/alpacaHead.svg"
          alt="logo"
          class="logo"
        >
      </li>
    </ul>
  </nav>
</template>
<script>
import { routes } from '@/router';
export default {
  name: 'NavbarSection',
  data () {
    return {
      links: routes.filter(({ ignore = false }) => !ignore)
    };
  }
};
</script>
